import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { TellentImpactTrackerHttpClient } from './tellent-impact-tracker.http';
import { TellentImpactTrackerActions } from './tellent-impact-tracker.store';

@Injectable({ providedIn: 'root' })
export class TellentImpactTrackerEffects {
  private readonly tellentImpactTrackerHttpClient = inject(TellentImpactTrackerHttpClient);
  private readonly actions$ = inject(Actions);

  public effects = createEffectFactory(TellentImpactTrackerActions, this.actions$);

  public fetch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentImpactTrackerActions.fetchCollection),
      mergeMap(() =>
        this.tellentImpactTrackerHttpClient.fetchCollection().pipe(
          map(data => TellentImpactTrackerActions.fetchCollectionSuccess({ payload: { data } })),
          catchError(error =>
            of(TellentImpactTrackerActions.fetchCollectionFailed({ payload: error })),
          ),
        ),
      ),
    ),
  );
}
